"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkForFirstPermittedMainTab = exports.hasAccessPermission = void 0;
var keycloak_1 = require("../constants/keycloak");
var frontendRoutes_1 = require("../constants/frontendRoutes");
/**
 * Given a list of permissions and a resource suffix, checks whether the user has access to this general functionality
 * (Model Management, Workbench, etc. ...)
 * @param permissions
 * @param resourceSuffix
 */
var hasAccessPermission = function (permissions, resourceSuffix) {
    return new Set((permissions === null || permissions === void 0 ? void 0 : permissions["".concat(keycloak_1.RESOURCE_TYPE_DASHBOARD_COMPONENT_PREFIX, ":").concat(resourceSuffix)]) || []).has(keycloak_1.DASHBOARD_COMPONENT_SCOPE_IDS.ACCESS);
};
exports.hasAccessPermission = hasAccessPermission;
/**
 * Get the link for the first main tab the user has permissions for
 * Used for example to get the link for the logo in the left top corner
 */
var getLinkForFirstPermittedMainTab = function (permissions) {
    if (!permissions)
        return null;
    var PRIORITIZED_ROUTES = [
        [keycloak_1.RESOURCE_TYPE_DASHBOARD_MODEL_MANAGEMENT_SUFFIX, frontendRoutes_1.routes.mainTabs.models],
        [keycloak_1.RESOURCE_TYPE_DASHBOARD_APPS_SUFFIX, frontendRoutes_1.routes.mainTabs.apps],
        [
            keycloak_1.RESOURCE_TYPE_DASHBOARD_WORKBENCH_COLLAB_SUFFIX,
            frontendRoutes_1.routes.mainTabs.workbench,
        ],
        [
            keycloak_1.RESOURCE_TYPE_DASHBOARD_ORCHESTRATION_SUFFIX,
            frontendRoutes_1.routes.mainTabs.orchestration,
        ],
        [keycloak_1.RESOURCE_TYPE_DASHBOARD_DATA_MANAGEMENT_SUFFIX, frontendRoutes_1.routes.mainTabs.data],
    ];
    for (var i = 0; i < PRIORITIZED_ROUTES.length; i++) {
        var _a = PRIORITIZED_ROUTES[i], resourceSuffix = _a[0], route = _a[1];
        if ((0, exports.hasAccessPermission)(permissions, resourceSuffix)) {
            return route;
        }
    }
    // Fallback: no permitted main tabs
    return frontendRoutes_1.routes.noMainTabs;
};
exports.getLinkForFirstPermittedMainTab = getLinkForFirstPermittedMainTab;
//# sourceMappingURL=authorization.general.js.map